/*
 * ShiftPlanningIssuesDialog Messages
 *
 * This contains all the text for the ShiftPlanningIssuesDialog component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  shiftPlanningIssuesTitle: {
    id: 'app.components.ShiftPlanningIssuesDialog.shiftPlanningIssuesTitle',
    defaultMessage: 'Week cannot be finalized',
  },
  weekHasUncommittedShifts: {
    id: 'app.components.ShiftPlanningIssuesDialog.weekHasUncommittedShifts',
    defaultMessage:
      'There are uncommitted shifts that prevent finalizing all shifts until the end of this week.',
  },
  close: {
    id: 'app.components.ShiftPlanningIssuesDialog.close',
    defaultMessage: 'Close',
  },
});
